import { createSignal } from '@verclam/pulsar';

export type FacilitySidebarContext = {
	readonly facilityId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the facility carried by `facilityId`; a
 * `facilityId` of `null` inside an open context creates one instead.
 */
const facilitySidebarSignal = createSignal<FacilitySidebarContext | null>(null);

export const openFacilitySidebar = (facilityId: number | null): void => {
	facilitySidebarSignal.value = { facilityId };
};

export const closeFacilitySidebar = (): void => {
	facilitySidebarSignal.value = null;
};

export default facilitySidebarSignal;
